import React, {useState, useEffect} from 'react'
import {Col, Collapse, Progress, Row, Typography} from "antd";
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import {SwapRightOutlined} from "@ant-design/icons";

const {Panel} = Collapse
const {Text, Paragraph} = Typography

const Productions = ({data: {pp}}) => {

    const viewStyle = {
        height: '50vh',
        overflowY: 'auto',
    }

    const renderProgress = ({q}) => {
        return (
            <React.Fragment>
                <span>{q} Adet</span>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className={'rql-view'} style={viewStyle}>
                <Collapse ghost={true}>
                    {
                        pp
                            ? pp.map((item, index) => {
                                return (
                                    <Panel header={`Reçete Kodu: ${item.rc}`} key={index} extra={renderProgress(item)}>
                                        <PanelItem item={item}/>
                                    </Panel>
                                )
                            })
                            : null
                    }
                </Collapse>
            </div>
        </React.Fragment>
    )
}

export default Productions

const PanelItem = ({item: {rn, sd, ed}}) => {

    const [percent, setPercent] = useState(Number)

    useEffect(() => {
        getPercent()
    }, [])

    const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around'
    }

    const dateIconStyle = {
        margin: '0 4px'
    }

    const getPercent = () => {
        const today = new Date().getTime()
        const startDay = new Date(sd).getTime()
        const endDay = new Date(ed).getTime()
        const startEndDiff = getDaysDiff(startDay, endDay)
        const todayStartDiff = getDaysDiff(startDay, today)
        setPercent(Math.floor((todayStartDiff / startEndDiff) * 100))
    }

    const getDaysDiff = (startDay, endDay) => (endDay - startDay) / (1000 * 60 * 60 * 24);

    return (
        <React.Fragment>
            <Row justify={'space-between'} gutter={16}>
                <Col style={{overflow: 'hidden'}}>
                   <Paragraph ellipsis={true} type={'secondary'}>{rn}</Paragraph>
                </Col>
                <Col>
                    <div style={containerStyle}>
                        <Text type={'secondary'}>{userDateFormatter(sd)}</Text>
                        <SwapRightOutlined style={dateIconStyle}/>
                        <Text type={'secondary'}>{userDateFormatter(ed)}</Text>
                    </div>
                </Col>
            </Row>
            <Row>
                <Progress percent={percent}  />
            </Row>
        </React.Fragment>
    )
}